import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Col, Modal, Row, Typography } from "antd";
import styles from "./styles/job-card.module.css";
import { stripHtml } from "string-strip-html";
import { formatSalary } from "@/helpers/Utils";

const JobCard = (props) => {
  const [detailedView, setDetailedView] = useState(false);
  const { job } = props;
  return (
    <>
      <Modal
        title={job?.title}
        open={detailedView}
        style={{ top: 20 }}
        onCancel={() => setDetailedView(false)}
        footer={
          <Button onClick={() => setDetailedView(false)} type={"link"}>
            Close
          </Button>
        }
      >
        <Typography.Paragraph className={styles.text}>
          Description:{" "}
          {job?.description ? stripHtml(job?.description)?.result : " -"}
        </Typography.Paragraph>
      </Modal>
      <div className={styles.wrapper}>
        <div className={styles.text_wrapper}>
          <Typography.Paragraph
            ellipsis={{ expandable: false, rows: 1 }}
            className={styles.title}
          >
            {job?.title}
          </Typography.Paragraph>
          <p className={styles.text}>
            <strong>Location:</strong> {job?.city}
          </p>
          <Typography.Paragraph
            ellipsis={{ expandable: false, rows: 3 }}
            className={styles.text}
          >
            <strong>Description:</strong>{" "}
            {job?.description ? stripHtml(job?.description)?.result : " -"}
          </Typography.Paragraph>
          {Object.keys(job?.salary).find((key) => job.salary[key]) &&
            !props?.hideSalaryData && (
              <>
                <Typography.Text strong style={{ display: "block" }}>
                  Pay:
                </Typography.Text>
                <Row style={{ width: "100%" }}>
                  <Col span={24}>
                    {job.salary.min || job.salary.max ? (
                      <Typography.Text>
                        {job.salary.min
                          ? formatSalary(job.salary.min, job.salary.currency)
                          : "-"}{" "}
                        -
                        {job.salary.max
                          ? formatSalary(job.salary.max, job.salary.currency)
                          : "-"}
                      </Typography.Text>
                    ) : null}
                  </Col>
                </Row>
                {job.salary.external ? (
                  <Row style={{ width: "100%" }}>
                    <Col span={24}>
                      <Typography.Text>
                        External:{" "}
                        {formatSalary(job.salary.external, job.salary.currency)}
                      </Typography.Text>
                    </Col>
                  </Row>
                ) : null}
                {job.salary?.text ? (
                  <Row style={{ width: "100%" }}>
                    <Col span={24}>
                      <Typography.Text>{job.salary.text}</Typography.Text>
                    </Col>
                  </Row>
                ) : null}
              </>
            )}
          {job?.benefits && (
            <strong className={styles.text}>Benefits: {job.benefits}</strong>
          )}
        </div>
        <Button
          type={"text"}
          block
          size={"large"}
          disabled={job.source === "volcanic" ? false : !props.isActive}
          onClick={() => {
            if (job.source === "volcanic") {
              window.open(job?.source_url, "_blank");
            } else {
              props.apply(job);
            }
          }}
          className={styles.button}
        >
          {job.source === "volcanic" ? "Read More / Apply" : "I'm interested"}
        </Button>
        {job.source !== "volcanic" && (
          <Button
            type={"text"}
            block
            disabled={!props.isActive}
            onClick={() => {
              setDetailedView(!detailedView);
            }}
            size={"large"}
            className={styles.button}
          >
            Show full description
          </Button>
        )}
      </div>
    </>
  );
};

JobCard.propTypes = {
  isActive: PropTypes.bool.isRequired,
  job: PropTypes.object.isRequired,
  apply: PropTypes.func.isRequired,
};

export default JobCard;
